<template>
  <div class="d-flex" style="gap: 8px">
    <v-text-field
      v-mask="'##/##/####'"
      placeholder="VD: 01/06/2026"
      v-model="date"
      type="text"
      color="primary"
      outlined
      validate-on-blur
      dense
      hide-details
      label="Ngày"
      :disabled="disabled"
    />
    <v-text-field
      v-mask="'##:##:##'"
      placeholder="VD: 17:00:00"
      v-model="time"
      type="text"
      color="primary"
      outlined
      validate-on-blur
      dense
      hide-details
      label="Thời gian"
      :disabled="disabled"
    />
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {value: String, disabled: Boolean},
  data: () => ({date: '', time: '17:00:00'}),
  methods: {
    getData() {
      if (this.date.length && this.time.length)
        return moment(`${this.date} ${this.time}`, 'DD/MM/YYYY HH:mm:ss').toISOString()
      return ''
    },
  },
  watch: {
    value: {
      handler(v) {
        if (typeof v === 'string' && v.length) {
          const [date, time] = moment(v).format('DD/MM/YYYY HH:mm:ss').split(' ')
          this.date = date
          this.time = time
        }
      },
      immediate: true,
    },
  },
}
</script>